"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "giavera-del-montello": {
    "db19dbdf": [{
      "hkey": "ff63fb14",
      "slug": "santi-angeli",
      "name": "Santi Angeli",
      "primary": true,
      "skipSearch": false
    }],
    "ss-angeli": [{
      "hkey": "ff63fb14",
      "slug": "santi-angeli",
      "name": "Santi Angeli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;